import React from 'react';

import {CopySection} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {ChannelPhoneProps} from './types';

export function ChannelPhone({value, mask = CopySectionMaskEnum.LONG_PHONE}: ChannelPhoneProps) {
	return <CopySection value={value} mask={mask} callAction highlightedIcons />;
}
